import { Navigate, Outlet, useParams } from 'react-router-dom'

import { getLocalizedPath, isLocale } from '@/content/i18n'
import { useAuth } from '@/hooks/useAuth'
import { dashboardCopy } from '@/content/dashboardContent'
import { getLocalizedValue } from '@/lib/utils'
import type { Locale } from '@/types/site'

export function RequireAdmin() {
  const { user, userLoading } = useAuth()
  const { locale: localeParam } = useParams<{ locale: string }>()

  if (!isLocale(localeParam)) {
    return null
  }

  const locale = localeParam as Locale

  if (userLoading) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-2 p-12 text-sm text-slate-500">
        <p>{getLocalizedValue(dashboardCopy.loadingDashboard, locale)}</p>
      </div>
    )
  }

  if (!user?.is_admin) {
    return <Navigate to={getLocalizedPath(locale, 'dashboard/profile')} replace />
  }

  return <Outlet />
}
